var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEntregaDespachado(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#CED6D7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.7806 31.1246C37.0224 30.914 38.1988 31.7563 38.4094 32.9981C38.4312 33.1288 38.4385 33.2523 38.4385 33.3757C38.4385 34.632 37.4146 35.6559 36.1583 35.6559C34.8947 35.6487 33.878 34.632 33.878 33.3757C33.878 33.245 33.8853 33.1216 33.9071 32.9981C34.0668 32.0396 34.8221 31.2843 35.7806 31.1246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9512 25.9179C41.0892 25.976 41.1836 26.1212 41.1764 26.2737V31.7564C41.1764 31.771 41.1764 31.7855 41.1764 31.8C41.1691 31.9961 41.0093 32.1413 40.8133 32.1341H39.6949C39.3173 31.0375 38.4604 30.1879 37.3712 29.8103C35.4177 29.1422 33.29 30.1806 32.6219 32.1341H31.6633V24.9448H38.6638L40.9512 25.9179Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6703 20.2392C31.6703 20.2392 31.6703 20.2319 31.6703 20.2247C31.6775 20.0141 31.8518 19.8543 32.0552 19.8616H35.5191C35.6643 19.8616 35.8023 19.9487 35.8676 20.0794L37.625 23.4925H31.6703V20.2392Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1866 31.0884C16.3049 31.0884 17.2562 31.8944 17.4377 32.9982C17.4595 33.129 17.4668 33.2524 17.4668 33.3759C17.4668 34.6322 16.4429 35.6561 15.1866 35.6561C13.9303 35.6488 12.9063 34.6322 12.9063 33.3686C12.8991 33.2524 12.9136 33.1362 12.9281 33.02C13.1097 31.909 14.061 31.0956 15.1866 31.0884Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2111 28.4311H9.80424V16.7056C9.80424 15.601 10.6997 14.7056 11.8042 14.7056H30.3896C31.4942 14.7056 32.3896 15.601 32.3896 16.7056V18.4091H32.0483C32.0411 18.4091 32.0338 18.4091 32.0266 18.4091C31.0172 18.4164 30.2038 19.2297 30.2111 20.2391V28.4311Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1682 27.5591H30.2109V32.134H18.73C18.3523 31.0375 17.4954 30.1879 16.4062 29.8102C14.4527 29.1422 12.325 30.1806 11.6569 32.134H10.1755C10.161 32.134 10.1465 32.134 10.1319 32.134C9.93587 32.1195 9.79063 31.9525 9.80515 31.7637V27.973C9.80515 27.7552 9.95039 27.5591 10.1682 27.5591Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.3726,
    height: 31.3726,
    fill: "white",
    transform: "matrix(-1 0 0 1 41.1768 9.80371)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntregaDespachado);
export default __webpack_public_path__ + "static/media/entrega-despachado.444e0605d4593108e754fca6f0afd6f9.svg";
export { ForwardRef as ReactComponent };